export default "__VITE_ASSET__D4C$2OG5__"